<template>
	<div class="body-footer footer-wrapper">
		<div class="lang-wrapper">
			<ul class="clearfix">
				<li><a href="#" @click="changeLocale('zh-CN')">简体</a></li>
				<li><a href="#" @click="changeLocale('zh-TW')">繁體</a></li>
				<li><a href="#" @click="changeLocale('en')">English</a></li>
        <li><a href="#" @click="changeLocale('ru_RU')">Pусский</a></li>
			</ul>
		</div>
		<div class="copy-right">
      <span>Copyright © {{year}} CZUR Technology Co.,Ltd. All rights reserved. <a href="https://beian.miit.gov.cn" target="_blank">辽ICP备13011158号-8</a></span>
		</div>
	</div>
</template>

<script>
  import Config from 'common/script/config.js'
  export default {
    name: 'czurfooter',
    data: function () {
      return {
        year: new Date().getFullYear()
      }
    },
    methods: {
      changeLocale (locale) {
        var requestLang = Config.getReqParam('lang')
        Config.cookieSet('lang', locale)
        if (requestLang !== undefined && requestLang !== '' && locale !== requestLang) {
          window.location.href = Config.urlRemoveParam('lang')
        }
        this.$emit('changeAppLocale', locale)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
	.footer-wrapper
		padding 4px 0 2px
		font-size 12px
		color #757575
		text-align center
		background #f4f4f4
		.lang-wrapper
			padding 8px 0
			ul
				display block
				margin 0 auto
				width 324px
				&>li
					display block
					list-style none
					float left
					width 80px
					text-align center
					border-right 1px solid #7f7f7f
					&:last-child
						border none

</style>



// WEBPACK FOOTER //
// footer.vue?f3d1b2ae